import { Component } from '@angular/core';

import { MapFilters } from '../map.enum';

@Component({
  selector: 'app-sub-navigation',
  templateUrl: './sub-navigation.component.html',
  styleUrls: ['./sub-navigation.component.scss'],
})
export class SubNavigationComponent {
  public mapFilters: typeof MapFilters = MapFilters;
}
